import AddressSelectionField from '../components/fields/AddressSelectionField';
import AddressSelectionReviewField from '../components/review/AddressSelectionReviewField';

/**
 * Custom address selection field UI for choosing between previously entered addresses.
 *
 * @param {Object} options - Configuration options. All properties besides `title` are forwarded to `ui:options`.
 * @param {string} options.title - The field title
 * @returns {UISchemaOptions} UI schema configuration
 */
export const addressSelectionUI = ({ title, ...uiOptions }) => ({
  'ui:title': title,
  'ui:webComponentField': AddressSelectionField,
  'ui:reviewField': AddressSelectionReviewField,
  'ui:options': {
    ...uiOptions,
    fieldSelection: true,
  },
});
